export default  resolveSupportedDrmType;

// info about drm https://drmtoday.com/platforms/ table 'HTML5 Browsers'
function resolveSupportedDrmType(userAgent){
  const {device = {}, browser = {}, os = {}} = userAgent;
  const browserVersion = parseFloat(browser.version);
  const [,drmType] = [
    [browser.name === 'Edge', 'playready'],
    [browser.name === 'IE' && browserVersion >= 11, 'playready'],
    [browser.name === 'Safari' && browserVersion >= 8, 'fairplay'],
    [browser.name === 'Chrome' && browserVersion >= 35, 'modular'],
    [browser.name === 'Chromium' && browserVersion >= 35, 'modular'],
    [browser.name === 'Firefox' && browserVersion >= 47 && os.name !== 'Linux', 'modular'],
    [browser.name === 'Opera' && browserVersion >= 31, 'modular'],
    [device.type === 'mobile' && device.vendor === 'Apple', 'fairplay'],
    [device.type === 'tablet' && device.vendor === 'Apple', 'fairplay'],
    [device.type === 'mobile' && device.vendor !== 'Apple', 'modular'],
    [device.type === 'tabled' && device.vendor !== 'Apple', 'modular'],
    [true] // fallback to undefined type
  ].find(([predicate]) => predicate);

  return drmType;
}
